import { Component, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { EmployeeInfoService } from '@core/services/employee-info.service';
import { PortalSettingsService } from '@core/services/portal-settings.service';
import { GainsightUser } from './models/gainsight-user.model';
import { GainsightAccount } from './models/gainsight-account.model';
import { HomeApiService } from '@pages/home/services/home.api.service';
import { GainsightInfo } from '@typeDefs/home/responses/home';

declare function installAptrinsicSDK(tagKey, sdkUrl): void;
declare function initializeAptrinsic(tagKey, sdkUrl, user, accunt): void;

@Component({
  selector: 'app-gainsight',
  templateUrl: './gainsight.component.html',
  styleUrl: './gainsight.component.scss',
  standalone: true
})
export class GainsightComponent implements OnInit {
  private employeeInfo = inject(EmployeeInfoService).getEmployeeInfo();
  private portalSettings$ = inject(PortalSettingsService).portalSettings$;
  private homeApiService = inject(HomeApiService);
  portalSettings = toSignal(this.portalSettings$);

  readonly tagKey = this.portalSettings().GainsightPXTag.ConfigValue;
  readonly sdkUrl = this.portalSettings().GainsightPXSdkUrl.ConfigValue;

  gainsightInfo: GainsightInfo;
  user: GainsightUser;
  account: GainsightAccount;

  ngOnInit(): void {
    if (this.employeeInfo != null)
      this.getGainsightInfo();
    else
      installAptrinsicSDK(this.tagKey, this.sdkUrl);
  }

  getGainsightInfo() {
    this.homeApiService.getGainsightInfo().subscribe(gainsightInfo => {
      this.gainsightInfo = gainsightInfo;
      this.initializeGainsight();
    })
  }


  initializeGainsight() {
    const isTimeClockEnabled = this.portalSettings().TCAllowApproverTimeWorkedEdit.ConfigValue == '1' && this.portalSettings().TCClockIOIgnoreJobPhase.ConfigValue == '1';
    const isTimeClockNonKiosk = isTimeClockEnabled && (this.portalSettings().ClockInUsePhase.ConfigValue == '1' || this.portalSettings().TCDisableNonPassKiosk.ConfigValue == '1');
    const email = this.employeeInfo.Email;
    const emailDomain = email != null && email.indexOf('@') > 0
    ? email.substring(this.employeeInfo.Email.indexOf('@'))
    : '';
    const trimbleID = this.employeeInfo.TrimbleID;
    const viewpointID = this.employeeInfo.ViewpointOneUserID;
    const userKeyID = this.gainsightInfo.CustomerID + "_" + this.employeeInfo.UserKeyID;
    let userID;

    if (trimbleID)
      userID = trimbleID
    else if (viewpointID)
      userID = viewpointID
    else
      userID = userKeyID;
    
    this.user = {
      employeeNum: this.employeeInfo.Employee,
      id: userID,
      email: email,
      emailDomain: emailDomain,
      firstName: this.employeeInfo.FirstName,
      lastName: this.employeeInfo.LastName,
      isSystemAdmin: this.employeeInfo.IsSystemAdmin,
      isHRUser: this.gainsightInfo.IsHRUser,
      isFieldUser: this.gainsightInfo.IsFMUser,
      isFCUser: this.gainsightInfo.IsFCUser,
      enableCrewEditing: this.employeeInfo.EnableCrewEditing,
      isTermLock: this.employeeInfo.IsTermLock == 1,
      isAuthFMMobile: this.employeeInfo.IsAuthFMMobile,
      isAuthFieldService: this.employeeInfo.IsAuthFieldService,
      isActiveTechnician: this.employeeInfo.IsActiveTechnician,
      isEverInvoiceReviewer: this.employeeInfo.IsEverInvoiceReviewer,
      otherAdmins: this.employeeInfo.Pendo_OtherAdmins,
      positionDesc: this.employeeInfo.PositionDesc
    }

    this.account = {
      id: this.portalSettings().SalesforceID.ConfigValue,
      name: this.portalSettings().CustomerName.ConfigValue,
      portalUrl: this.portalSettings().HRPortalAddress.ConfigValue,
      portalVersion: this.gainsightInfo.PortalVersion,
      vistaVersion: this.gainsightInfo.VistaVersion,
      customerID: this.gainsightInfo.CustomerID,
      countryCode: this.portalSettings().CountryDateCode.ConfigValue,
      timeClockEnabled: isTimeClockEnabled,
      timeClockNonKiosk: isTimeClockNonKiosk,
      licenseHR: this.gainsightInfo.LicenseHR,
      licenseFC: this.gainsightInfo.LicenseFC,
      licenseFM: this.gainsightInfo.LicenseFM,
      licenseFS: this.gainsightInfo.LicenseFS
    }

    initializeAptrinsic(this.tagKey, this.sdkUrl, this.user, this.account);
  }
  

  

}
